/**
 * export-modal.component.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DialogRef, ModalComponent } from "angular2-modal";
import { BSModalContext } from "angular2-modal/plugins/bootstrap";
import { Observable } from "rxjs/Rx";
import { IntakeStep } from "../algorithms/structure/intake-step";
import { SubjectContextType } from "../subjects/subject-context-type";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

export interface SubjectExportModalContext extends BSModalContext
{
  steps : IntakeStep[];
  type : SubjectContextType;
  algorithm : string;
}

const EXPORT_VERSION : number = 2;
const JSON_HEADER : string = "data:text/json;charset=utf-8,";

@Component({
  template: `
  <div class="modal-header">
    <button
      type="button"
      class="close"
      (click)="dialog.dismiss()"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
      Export Subject Data to File
    </h4>
  </div>
  <div class="modal-body">
    <h3 class="debug-only">Caution!</h3>
    <p>
      This feature is currently <u>experimental</u> and should only be used in
      case of emergency. The format used in these files is not yet stable, so
      files you create now may not successfully import in the future!
    </p>
    <p>
      <em>In addition,</em> these files contain unencrypted personal information
      that can be easily read by humans. Treat the data with care (never send
      them over the internet or leave them on an unlocked device) and fully
      delete them as soon as you are done with them!
    </p>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-default"
      (click)="dialog.dismiss()">
      Cancel
    </button>
    <a
      type="button"
      class="btn btn-warning"
      [href]="data"
      download="export.json">
      Download
    </a>
  </div>
  `,
  styles: [
    "/deep/ prettyjson pre {outline: none !important;}",
    "/deep/ #sendButton {position: relative; top: -8px;}"
  ]
})
export class ExportModalComponent
  implements ModalComponent<SubjectExportModalContext>, OnInit
{
  public data : SafeUrl;

  constructor (
    public dialog : DialogRef<SubjectExportModalContext>,
    public sanitizer : DomSanitizer
  ) {}

  public ngOnInit () : void
  {
    const stepOutput : object = {};
    let stepCount : number = 0;
    this.dialog.context.steps.forEach((step : IntakeStep) => {
      // TODO: handling for weird values? any skips?
      stepOutput[step.name] = step.value;
      stepCount++;
    });
    const json : string = JSON.stringify({
      version: EXPORT_VERSION,
      type: this.dialog.context.type,
      algorithm: this.dialog.context.algorithm,
      stepCount,
      steps: stepOutput
    });

    this.data = this.sanitizer.bypassSecurityTrustUrl(
      JSON_HEADER + encodeURIComponent(json));
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/intake-form/export-modal.component.ts